import { State } from 'state';
import { StoreEnhancer } from 'redux';
import { DigitalData } from 'hooks/useAnalyticVariables';

export type ScanResult = {
  type: string;
  bytes: Iterable<number>;
  count: number;
  code: number;
  codes: {
    type: string;
    code: number;
  }[];
};

export interface IdiSdkInit {
  cardholderFirstName: string;
  cardholderLastName: string;
  cardNickname: string;
  localeLanguage: string;
  localeCountry: string;
  isTestEnvironment: boolean;
  GOOGLE_integratorId?: string;
  GOOGLE_hl?: string;
  APPLE_buttonId?: string;
}

export interface IdiSdk {
  initialize: (
    options: IdiSdkInit,
    callback: (passthruFromIdiSdk: { payload: string }) => unknown,
    responseCallback?: (response: {
      result?: 'success' | 'failure' | 'cancel';
      message?: string;
    }) => unknown,
  ) => void;
  selection: (consumerFacingEntityName: string) => void;
  addCard: (passthruToIdiSdk: string) => void;
  interpret: (
    querystring: string,
  ) => {
    result: 'success' | 'failure' | 'cancel';
    state: string;
    tokenUniqueReference: string;
  };
}

declare global {
  interface Window {
    Dynamic_DOM_Elements: {
      previewFrame: HTMLElement;
    };
    idiSDK: IdiSdk;
    mwbScanner: {
      startScanning: (callBack: (result: ScanResult) => Promise<void>) => void;
      closeScanner: () => void;
    };
    __PRELOADED_STATE__?: State;
    __INITIAL_I18N_STORE__: string;
    __INITIAL_LANGUAGE__: string;

    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: (
      ...funcs: StoreEnhancer[]
    ) => StoreEnhancer;
    store?: {
      getState: () => State;
    };
    Cypress: unknown;
    s?: unknown;
    _satellite: {
      getVisitorId: () => {
        getMarketingCloudVisitorID: () => string;
      };
    };
    digitalData: DigitalData;
  }
}

export default (typeof window !== 'undefined' ? window : {}) as Window;
